










































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { quotes, quotesWithQuotee } from '@/modules/dashboard/models/admin-dashboard-quotes'
import { Prop } from 'vue-property-decorator'

export interface quoteModel {
  quote: string,
  quotee: string
}

@Component({
  components: {}
})
export default class WidgetQuote extends Vue {

  $refs !: {
    textContainer: HTMLDivElement,
  }

  @Prop({ default: false }) dark!: boolean
  text: string[] | quoteModel[] = this.quoteProvider
  subText: string = ''

  mounted() {
    this.fetchQuotes()
  }

  //Computed
  get quoteProvider() {
    const probabilityChance = 5
    const indexProbability = Math.floor(Math.random() * probabilityChance/*quoteList.length*/)
    const index = (indexProbability > 0) ? 0 : 1
    const quoteList = [quotes, quotesWithQuotee]
    return quoteList[index]
  }

  get showText() {
    const index = Math.floor(Math.random() * this.text.length)
    if (this.isArray(this.text)) {
      this.subText = 'Elon Musk'
      return this.text[index]
    } else {
      this.subText = this.text[index]['quotee']
      return this.text[index]['quote']
    }
  }

  isArray(value) {
    return Array.isArray(value) && value.every(item => typeof item === 'string')
  }

  async fetchQuotes() {
    let token = '816840:640586f79541b'
    let data = await fetch(`https://one-api.ir/sokhan/?token=${token}&action=random`) //https://panel.one-api.ir/
    let text = await data.json()
    this.text = [{ 'quote': text['result']['text'], 'quotee': text['result']['author'] }]
  }

}

